<template>
    <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 14.87 16.99"
    >
        <path
            id="Icon_awesome-share-alt-2"
            data-name="Icon awesome-share-alt-2"
            class="cls-1"
            d="M11.69,10.62a3.17,3.17,0,0,0-2,.69L6.3,9.18a3.21,3.21,0,0,0,0-1.38L9.7,5.67a3.17,3.17,0,1,0-1.13-1.8L5.17,6a3.19,3.19,0,1,0,0,5l3.4,2.12a3.19,3.19,0,1,0,3.8-2.42,3.1,3.1,0,0,0-.69-.08Z"
        />
    </svg>
</template>

<script>
export default {
    name: 'ShareIcon'
}
</script>

<style lang="scss" scoped>
svg {
    width: 14.87px;
    height: 16.99px;
    margin: auto;
    path {
        fill: $white;
    }
}
svg:hover {
    path {
        fill: $blue;
    }
}
</style>